import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateWizardStep,
  completeWizardStep,
  setDischargeDataStart,
  setDischargeDataSuccess,
  setDischargeDataFailure,
  setSelectedFile,
  toggleEditMode,
  updateField,
  saveChanges,
  setWizardSteps,
  fetchSchemeById,
  setToggleEditMode,
  fetchDoctorTypeList,
  submitDischargeData,
  submitDischargeDataInEdgePro,
  updateDischargeDataField,
  UploadDocument,
  updateEditedFields,
  fetchStarHealthRoomTypeList,
  dischargeSummaryReaderResponse,
  intimateSubmitDischarge,
  setCaseDischargeValue,
} from "../../models/DischargeSlice";
import Discharge from "../../components/patient/Discharge/Discharge";
import {
  DischargeState,
  DischargeResponse,
  DischargeField,
  DischargeSection,
} from "../../interfaces/IDischarge";
import { AppDispatch, RootState } from "../../store/store";
import {
  deleteUploadedDocument,
  dischargeService,
  downloadDocument,
  submitApproval,
} from "../../apis/patientService";
import FilePreviewModal from "../../components/patient/PreAuth-query/FilePreviewModal";
import { message } from "antd";
import { clearUploadedDocumentUrlsAfterSave } from "../../models/EnhancementSlice";
import { IDocumentFields } from "../../interfaces/ICase";
import dayjs from "dayjs";
import RightSidePreviewModal from "../../components/modals/RightSidePreviewModal";
import {
  dischargeSummaryMessage,
  errorMessage,
  successMessage,
} from "../../utils/notificationUtils";
import { DOCUMENTS } from "../../utils/constants";
import {
  clearDeficiencyCheck,
  getDeficiencyQuestionData,
  getDeficiencyQuestions,
} from "../../models/patientSlice";
import DocumentDeficiencyModal from "../../components/patient/DocumentDeficiencyModal";
import {
  fetchPreAuthStepper,
  setCanNavigate,
  setCurrentStep,
} from "../../models/preAuthSlice";
import { useLocation } from "react-router-dom";
import Loader from "../../utils/Spinners";

interface DischargeContainerProps {
  onfetchStepper: () => void; // Define prop type for the function
  nextStage: any;
  setMoveToNext: CallableFunction;
  stepperForStatus: CallableFunction;
}

const DischargeContainer: React.FC<DischargeContainerProps> = ({
  onfetchStepper,
  nextStage,
  setMoveToNext,
  stepperForStatus,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [caseDischargeId, setCaseDischargeId] = useState<number | null>(null);
  const [portalSubmission, setPortalSubmission] = useState<string | null>(null);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [billingFields, setBillingFields] = useState<string[]>([]);
  const [uploadedDocumentUrl, setUploadedDocumentUrl] = useState<
    Array<IDocumentFields>
  >([]);
  const { patients, hospital, preAuth, auth, discharge, preAuthClaim } =
    useSelector((state: RootState) => state);
  const { isSubmitting } = useSelector((state: RootState) => state.discharge);
  const [isFetchingDischargeData, setIsFetchingDischargeData] =
    useState<boolean>(false);
  const [treatingDoctorTypeOptions, setTreatingDoctorTypeOptions] = useState<
    Array<{ label: string; value: string }>
  >([{ label: "OTHERS", value: "O" }]);
  const {
    allWizardSteps,
    activeStep,
    dischargeData,
    isLoading,
    error,
    editMode,
    editedFields,
  }: DischargeState = useSelector((state: RootState) => state.discharge);
  const getIds = useSelector((state: RootState) => state.patients);
  const selectedFile = useSelector(
    (state: RootState) => state.discharge.selectedFile
  );
  const [documentUrl, setDocumentUrl] = useState<string>("");
  const [previewDocument, setPreviewDocument] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(
    null
  ); //to send document id for deficiency check
  const [documentName, setDocumentName] = useState("");
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [DSPath, setDSPath] = useState<string | null>(null);
  const location = useLocation();
  const currentVisitStage = preAuth?.stepperData.currentVisitStage;
  const currentStep = preAuth?.stepperData.visitStages[preAuth?.currentStep];
  const [isDownloadingDocument, setIsDownloadingDocument] =
    useState<boolean>(false);
  const [downloadingDocumentUrl, setDownloadingDocumentUrl] =
    useState<string>("");

  useEffect(() => {
    message.destroy();
  }, [location.pathname, discharge?.activeStep]);

  useEffect(() => {
    const fetchDischargeData = async () => {
      dispatch(setDischargeDataStart());
      let editedFields = {};
      try {
        setIsFetchingDischargeData(true);
        const data = await dischargeService.getDischargeData(
          getIds?.fetchBasicDetails?.casesResponse?.id,
          getIds?.fetchBasicDetails?.visitInfoResponse?.id,
          discharge?.selectedScheme?.portalMetaDataIdsList[0]
        );
        setIsFetchingDischargeData(false);
        getAttachmentsWithValues(data);
        dispatch(setDischargeDataSuccess(data));
        if (data?.ihxDischargeResponses) {
          const caseDischargeId =
            data?.ihxDischargeResponses?.[0]?.["Basic Details"]?.[0]
              ?.caseDischargeId;
          const portalSubmitCheck =
            data?.ihxDischargeResponses?.[0]?.["Basic Details"]?.[0]?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
          if (caseDischargeId) {
            setCaseDischargeId(caseDischargeId);
          } else {
            console.warn("Case Discharge ID not found in the response");
          }
          dispatch(
            setWizardSteps([
              {
                step: 0,
                title: "Basic Details",
                canNavigate: true,
                completed: false,
              },
              {
                step: 1,
                title: "Billing Details",
                canNavigate: true,
                completed: false,
              },
            ])
          );
        } else if (data?.cghsDischargeResponse) {
          const caseDischargeId =
            data?.cghsDischargeResponse?.[0]?.["Discharge"]?.[0]
              ?.caseDischargeId;
          const portalSubmitCheck =
            data?.cghsDischargeResponse?.[0]?.["Discharge"]?.[0]?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
          if (caseDischargeId) {
            setCaseDischargeId(caseDischargeId);
            // dispatch(setCanNavigate({ step: 4, canNavigate: true }));
          } else {
            console.warn("Case Discharge ID not found in the response");
            // dispatch(setEnhancementDataFailure(error instanceof Error ? error.message : "An unknown error occurred"));
          }

          if (auth?.role?.role == "FO_STAFF") {
            dispatch(
              setWizardSteps([
                {
                  step: 0,
                  title: "Discharge Details",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 1,
                  title: "Discharge Documents",
                  canNavigate: false,
                  completed: false,
                },
              ])
            );
          } else {
            dispatch(
              setWizardSteps([
                {
                  step: 0,
                  title: "Discharge Details",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 1,
                  title: "Discharge Documents",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 2,
                  title: "COVID Case Details",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 3,
                  title: "Treating Doctor Details",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 4,
                  title: "Treatment/Surgery Date",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 5,
                  title: "Discharge Summary",
                  canNavigate: true,
                  completed: false,
                },

                {
                  step: 6,
                  title: "Discharge",
                  canNavigate: true,
                  completed: false,
                },
              ])
            );
          }
        } else if (data?.starHealthDischargeResponse) {
          editedFields = {
            starHealthDischargeResponse: data.starHealthDischargeResponse,
          };
          const portalSubmitCheck =
            data?.starHealthDischargeResponse?.[0]?.["Basic Details"]?.[0]
              ?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
          const caseDischargeId =
            data?.starHealthDischargeResponse?.[0]?.["Basic Details"]?.[0]
              ?.caseDischargeId;
          if (caseDischargeId) {
            setCaseDischargeId(caseDischargeId);
          } else {
            console.warn("Case Discharge ID not found in the response");
            // dispatch(setEnhancementDataFailure(error instanceof Error ? error.message : "An unknown error occurred"));
          }

          dispatch(
            setWizardSteps([
              {
                step: 0,
                title: "Documents",
                canNavigate: true,
                completed: false,
              },
              {
                step: 1,
                title: "Basic Details",
                canNavigate: true,
                completed: false,
              },
              {
                step: 2,
                title: "Add Treating doctor details",
                canNavigate: true,
                completed: false,
              },
              // {
              //   step: 2,
              //   title: "Documents",
              //   canNavigate: true,
              //   completed: false,
              // },
            ])
          );
        } else if (data?.echsDischargeResponse) {
          editedFields = {
            echsDischargeResponse: data.echsDischargeResponse,
          };

          const portalSubmitCheck =
            data?.echsDischargeResponse?.[0]?.["Basic Details"]?.[0]?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
          const caseDischargeId =
            data?.echsDischargeResponse?.[0]?.["Basic Details"]?.[0]
              ?.caseDischargeId;

          if (caseDischargeId) {
            setCaseDischargeId(caseDischargeId);
          } else {
            console.warn("Case Discharge ID not found in the response");
            // dispatch(setEnhancementDataFailure(error instanceof Error ? error.message : "An unknown error occurred"));
          }

          if (auth?.role?.role == "FO_STAFF") {
            dispatch(
              setWizardSteps([
                // {
                //   step: 0,
                //   title: "Discharge Details",
                //   canNavigate: true,
                //   completed: false,
                // },
                // {
                //   step: 1,
                //   title: "Upload Documents",
                //   canNavigate: true,
                //   completed: false,
                // },
                {
                  step: 0,
                  title: "Basic Details",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 1,
                  title: "Admission",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 2,
                  title: "Bill Details",
                  canNavigate: true,
                  completed: false,
                },
              ])
            );
          } else {
            dispatch(
              setWizardSteps([
                // {
                //   step: 0,
                //   title: "Discharge Details",
                //   canNavigate: true,
                //   completed: false,
                // },
                // {
                //   step: 1,
                //   title: "Upload Documents",
                //   canNavigate: true,
                //   completed: false,
                // },
                // {
                //   step: 2,
                //   title: "Basic Details",
                //   canNavigate: true,
                //   completed: false,
                // },
                // {
                //   step: 3,
                //   title: "Admission",
                //   canNavigate: true,
                //   completed: false,
                // },
                // {
                //   step: 4,
                //   title: "Bill Details",
                //   canNavigate: true,
                //   completed: false,
                // },
                // {
                //   step: 5,
                //   title: "Clinical Finding",
                //   canNavigate: true,
                //   completed: false,
                // },
                // {
                //   step: 6,
                //   title: "Line of Treatment",
                //   canNavigate: true,
                //   completed: false,
                // },
                // {
                //   step: 5,
                //   title: "Upload Documents",
                //   canNavigate: true,
                //   completed: false,
                // },
                {
                  step: 0,
                  title: "Basic Details",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 1,
                  title: "Admission",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 2,
                  title: "Bill Details",
                  canNavigate: true,
                  completed: false,
                },
              ])
            );
          }
        }
      } catch (error) {
        setIsFetchingDischargeData(false);
        dispatch(
          setDischargeDataFailure(
            error instanceof Error ? error.message : "An unknown error occurred"
          )
        );
      }
    };

    if (
      getIds?.fetchBasicDetails?.casesResponse?.id &&
      getIds?.fetchBasicDetails?.visitInfoResponse?.id &&
      discharge?.selectedScheme?.portalMetaDataIdsList[0]
    )
      fetchDischargeData();
    stepperForStatus();
  }, [
    dispatch,
    getIds?.fetchBasicDetails?.casesResponse?.id,
    getIds?.fetchBasicDetails?.visitInfoResponse?.id,
    discharge?.selectedScheme?.portalMetaDataIdsList[0],
    caseDischargeId,
    portalSubmission,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedDocumentId) {
          // dispatch(clearDeficiencyCheck());
          // const firstRes = await dispatch(
          //   getDeficiencyQuestions(selectedDocumentId)
          // );

          if (selectedDocument?.id) {
            const secondRes = await dispatch(
              getDeficiencyQuestionData(selectedDocument?.id)
            );
          }
        }
      } catch (err) {
        errorMessage("Please, Try again after sometime");
        setSelectedDocumentId(null);
        setSelectedDocument(null);
      }
    };

    if (selectedDocumentId || selectedDocument?.id) fetchData();
  }, [selectedDocumentId, selectedDocument?.id]);

  useEffect(() => {
    if (caseDischargeId) {
      if (
        currentStep?.visitStage === "Discharge" &&
        currentVisitStage &&
        currentStep &&
        currentStep?.visitStageId &&
        currentVisitStage?.visitStageId &&
        (currentVisitStage?.state == null ||
          currentStep?.visitStageId > currentVisitStage?.visitStageId)
      ) {
        dispatch(setCaseDischargeValue(caseDischargeId));
        dispatch(setToggleEditMode(true));
      }
    }
  }, [caseDischargeId]);

  const handleDeficiencyModalOpen = (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields
  ) => {
    setPreviewDocumentUrl(documentUrl);
    setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDeficiencyModalAfterSave = (
    documentUrl: string,
    documentId: number,
    field: any
  ) => {
    const document = {
      id: field?.documentId,
      documentName: field?.documentName,
      documentType: field?.labelId,
      documentUrl: field?.data,
      documentLabelType: field?.label,
      deficiencyCheckStatus: field?.deficiencyCheckStatus,
    };
    setPreviewDocumentUrl(documentUrl);
    setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocumentId(null);
    setSelectedDocument(null);
  };

  const getAttachmentsWithValues = (dischargeData: DischargeResponse) => {
    const attachmentsWithValues: Array<IDocumentFields> = [];
    if (dischargeData.cghsDischargeResponse) {
      const attachments =
        dischargeData?.cghsDischargeResponse?.[0]["Discharge Documents"];

      attachments?.forEach((attachment) => {
        if (
          attachment?.documentsList &&
          attachment?.documentsList?.length > 0
        ) {
          attachment?.documentsList?.forEach((document) => {
            attachmentsWithValues.push({
              documentName: document?.documentName,
              documentType: document?.documentType,
              documentUrl: document?.documentUrl,
              id: document?.id,
              deficiencyCheckStatus: document?.deficiencyCheckStatus,
              documentLabelType: document?.documentLabelType,
            });
          });
        }
      });
    } else if (dischargeData.ihxDischargeResponses) {
      const attachments = dischargeData?.ihxDischargeResponses?.[0][
        "Basic Details"
      ]?.filter(
        (doc) =>
          doc?.type === "document-upload" || doc?.type === "document-show"
      );
      attachments?.forEach((attachment) => {
        if (
          attachment?.documentsList &&
          attachment?.documentsList?.length > 0
        ) {
          attachment?.documentsList?.forEach((document) => {
            attachmentsWithValues.push({
              documentName: document?.documentName,
              documentType: document?.documentType,
              documentUrl: document?.documentUrl,
              id: document?.id,
              deficiencyCheckStatus: document?.deficiencyCheckStatus,
              documentLabelType: document?.documentLabelType,
            });
          });
        }
        // if (attachment?.data && attachment?.documentName) {
        //   attachmentsWithValues.push({
        //     documentName: attachment?.documentName,
        //     documentType: attachment?.labelId,
        //     documentUrl: attachment?.data,
        //     id: attachment?.documentId,
        //     deficiencyCheckStatus: attachment?.deficiencyCheckStatus,
        //     documentLabelType: attachment?.label,
        //   });
        // }
      });
    } else if (dischargeData?.starHealthDischargeResponse) {
      const attachments =
        dischargeData?.starHealthDischargeResponse?.[0]?.["Documents"];

      attachments?.forEach((attachment) => {
        if (
          attachment?.documentsList &&
          attachment?.documentsList?.length > 0
        ) {
          attachment?.documentsList?.forEach((document) => {
            attachmentsWithValues.push({
              documentName: document?.documentName,
              documentType: document?.documentType,
              documentUrl: document?.documentUrl,
              id: document?.id,
              deficiencyCheckStatus: document?.deficiencyCheckStatus,
              documentLabelType: document?.documentLabelType,
            });
          });
        }
      });
    } else if (dischargeData?.echsDischargeResponse) {
      const attachments =
        dischargeData?.echsDischargeResponse?.[0]?.["Upload Documents"];

      attachments?.forEach((attachment) => {
        if (
          attachment?.documentsList &&
          attachment?.documentsList?.length > 0
        ) {
          attachment?.documentsList?.forEach((document) => {
            attachmentsWithValues.push({
              documentName: document?.documentName,
              documentType: document?.documentType,
              documentUrl: document?.documentUrl,
              id: document?.id,
              deficiencyCheckStatus: document?.deficiencyCheckStatus,
              documentLabelType: document?.documentLabelType,
            });
          });
        }
      });
    }
    setUploadedDocumentUrl(attachmentsWithValues);
  };

  // const getAttachmentsWithValues = (dischargeData: DischargeResponse) => {
  //   const attachmentsWithValues: Array<IDocumentFields> = [];
  //   if (dischargeData.cghsDischargeResponse) {
  //     const attachments =
  //       dischargeData?.cghsDischargeResponse?.[0]["Discharge Documents"];

  //     attachments?.forEach((attachment) => {
  //       if (attachment?.data && attachment?.documentName) {
  //         attachmentsWithValues.push({
  //           documentName: attachment?.documentName,
  //           documentType: attachment?.labelId,
  //           documentUrl: attachment?.data,
  //           id: attachment?.documentId,
  //           deficiencyCheckStatus: attachment?.deficiencyCheckStatus,
  //           documentLabelType: attachment?.label,
  //         });
  //       }
  //     });
  //   } else if (dischargeData.ihxDischargeResponses) {
  //     const attachments = dischargeData?.ihxDischargeResponses?.[0][
  //       "Basic Details"
  //     ]?.filter(
  //       (doc) =>
  //         doc?.type === "document-upload" || doc?.type === "document-show"
  //     );
  //     attachments?.forEach((attachment) => {
  //       if (attachment?.data && attachment?.documentName) {
  //         attachmentsWithValues.push({
  //           documentName: attachment?.documentName,
  //           documentType: attachment?.labelId,
  //           documentUrl: attachment?.data,
  //           id: attachment?.documentId,
  //           deficiencyCheckStatus: attachment?.deficiencyCheckStatus,
  //           documentLabelType: attachment?.label,
  //         });
  //       }
  //     });
  //   } else if (dischargeData?.starHealthDischargeResponse) {
  //     const attachments =
  //       dischargeData?.starHealthDischargeResponse?.[0]?.["Documents"];

  //     attachments?.forEach((attachment) => {
  //       if (attachment?.data && attachment?.documentName) {
  //         attachmentsWithValues.push({
  //           documentName: attachment?.documentName,
  //           documentType: attachment?.labelId,
  //           documentUrl: attachment?.data,
  //           id: attachment?.documentId,
  //           deficiencyCheckStatus: attachment?.deficiencyCheckStatus,
  //           documentLabelType: attachment?.label,
  //         });
  //       }
  //     });
  //   }
  //   setUploadedDocumentUrl(attachmentsWithValues);
  // };

  useEffect(() => {
    dispatch(updateWizardStep(0));
  }, []);

  const handleNext = async () => {
    if (discharge?.activeStep === 1 && dischargeData?.cghsDischargeResponse) {
      const newData = await dischargeService.getDischargeData(
        getIds?.fetchBasicDetails?.casesResponse?.id,
        getIds?.fetchBasicDetails?.visitInfoResponse?.id,
        discharge?.selectedScheme?.portalMetaDataIdsList[0]
      );

      if (
        !newData?.cghsDischargeResponse?.[0]?.["Discharge Summary Processed"]
      ) {
        dischargeSummaryMessage("Wait! Discharge summary is getting read", 8);
        return;
      } else if (
        discharge?.activeStep === 1 &&
        dischargeData?.echsDischargeResponse
      ) {
        const newData = await dischargeService.getDischargeData(
          getIds?.fetchBasicDetails?.casesResponse?.id,
          getIds?.fetchBasicDetails?.visitInfoResponse?.id,
          discharge?.selectedScheme?.portalMetaDataIdsList[0]
        );

        if (
          !newData?.echsDischargeResponse?.[0]?.["Discharge Summary Processed"]
        ) {
          errorMessage(
            "Please, Wait For Sometime, Discharge Summary is getting processed",
            8
          );
          return;
        }
      } else {
        getAttachmentsWithValues(newData);
        dispatch(setDischargeDataSuccess(newData));
      }
    }
    dispatch(updateWizardStep(activeStep + 1));
  };

  const onKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    fieldId: string,
    value: string,
    sectionKey: string
  ) => {
    if (e.key === "Enter") {
      if (fieldId?.toLowerCase()?.includes("date")) {
        dispatch(
          updateField({
            sectionKey,
            fieldId,
            value: dayjs(value, "DD-MM-YYYY HH:mm:ss"),
          })
        );
      }
    }
  };

  const handlePrevious = () => {
    dispatch(updateWizardStep(activeStep - 1));
  };

  const handleComplete = (step: number) => {
    dispatch(completeWizardStep(step));
  };

  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };

  const handleOpen = () => {
    setPreviewDocument(true);
  };

  const handleSetDocumentUrl = (url: string) => {
    setDocumentUrl(url);
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      setDownloadingDocumentUrl(url);
      setIsDownloadingDocument(true);
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    } catch (err: any) {
      errorMessage("Please, Try again later");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    }
  };

  useEffect(() => {
    if (dischargeData?.cghsDischargeResponse) {
      uploadedDocumentUrl?.forEach((doc) =>
        dispatch(
          updateField({
            sectionKey: "cghsDischargeResponse",
            fieldId: doc?.documentLabelType?.split(" ").join("_"),
            value: doc?.documentUrl,
          })
        )
      );
    } else if (dischargeData?.ihxDischargeResponses) {
      uploadedDocumentUrl?.forEach((doc) =>
        dispatch(
          updateField({
            sectionKey: "ihxDischargeResponses",
            fieldId: doc?.documentLabelType?.split(" ").join("_"),
            value: doc?.documentUrl,
          })
        )
      );
    } else if (dischargeData?.echsDischargeResponse) {
      uploadedDocumentUrl?.forEach((doc) =>
        dispatch(
          updateField({
            sectionKey: "echsDischargeResponse",
            fieldId: doc?.documentLabelType?.split(" ").join("_"),
            value: doc?.documentUrl,
          })
        )
      );
    } else if (dischargeData?.starHealthDischargeResponse) {
      uploadedDocumentUrl?.forEach((doc) =>
        dispatch(
          updateField({
            sectionKey: "starHealthDischargeResponse",
            fieldId: doc?.documentLabelType?.split(" ").join("_"),
            value: doc?.documentUrl,
          })
        )
      );
    }
  }, [uploadedDocumentUrl, discharge?.dischargeData, discharge?.editMode]);

  const handleFileChange = (documentType: string) => (e: any) => {
    const maxSize = 15 * 1024 * 1024;
    if (dischargeData?.cghsDischargeResponse) {
      if (Array.isArray(e)) {
        return e;
      }
      // if (e?.file?.size > maxSize) {
      //   errorMessage("File Limit must be less than or equal to 15 MB");
      //   return;
      // }
      if (e?.file) {
        dispatch(setSelectedFile({ file: e.file, documentType: documentType }));
        setPreviewFile({
          url: URL.createObjectURL(e.file),
          name: e.file.name,
          showUpload: true,
          documentType: documentType,
        });
        setPreviewModalVisible(true);
      }
      return e?.target?.files;
    } else {
      if (Array.isArray(e)) {
        return e;
      }
      // if (e?.file?.size > maxSize) {
      //   errorMessage("File Limit must be less than or equal to 15 MB");
      //   return;
      // }
      if (e?.file) {
        dispatch(setSelectedFile({ file: e.file, documentType: documentType }));
        setPreviewFile({
          url: URL.createObjectURL(e.file),
          name: e.file.name,
          showUpload: true,
          documentType: documentType,
        });
        setPreviewModalVisible(true);
      }
      return e?.target?.files;
    }
  };

  const handleTabsChange = (activeStep: string) => {
    dispatch(updateWizardStep(parseInt(activeStep)));
  };

  useEffect(() => {
    if (dischargeData && caseDischargeId === null) {
      const initialEditedFields: Record<string, Record<string, any>> = {};
      Object.keys(dischargeData)?.forEach((key) => {
        const sections = dischargeData[key as keyof DischargeResponse] as
          | DischargeSection[]
          | undefined;
        if (sections) {
          sections?.forEach((section) => {
            Object.entries(section)?.forEach(([sectionTitle, fields]) => {
              if (Array.isArray(fields)) {
                fields?.forEach((field: DischargeField) => {
                  if (!initialEditedFields[key]) {
                    initialEditedFields[key] = {};
                  }
                  initialEditedFields[key][field.id] = field.data ?? null;
                });
              }
            });
          });
        }
      });
      dispatch(
        updateField({
          sectionKey: "all",
          fieldId: "all",
          value: initialEditedFields,
        })
      );
      dispatch(setToggleEditMode(true));
    } else if (dischargeData && portalSubmission) {
      const initialEditedFields: Record<string, Record<string, any>> = {};
      Object.keys(dischargeData)?.forEach((key) => {
        const sections = dischargeData[key as keyof DischargeResponse] as
          | DischargeSection[]
          | undefined;
        if (sections) {
          sections?.forEach((section) => {
            Object.entries(section)?.forEach(([sectionTitle, fields]) => {
              if (Array.isArray(fields)) {
                fields?.forEach((field: DischargeField) => {
                  if (!initialEditedFields[key]) {
                    initialEditedFields[key] = {};
                  }
                  initialEditedFields[key][field.id] = field.data ?? null;
                });
              }
            });
          });
        }
      });
      dispatch(
        updateField({
          sectionKey: "all",
          fieldId: "all",
          value: initialEditedFields,
        })
      );
      dispatch(setToggleEditMode(false));
    } else if (dischargeData && caseDischargeId) {
      const initialEditedFields: Record<string, Record<string, any>> = {};
      Object.keys(dischargeData)?.forEach((key) => {
        const sections = dischargeData[key as keyof DischargeResponse] as
          | DischargeSection[]
          | undefined;
        if (sections) {
          sections?.forEach((section) => {
            Object.entries(section)?.forEach(([sectionTitle, fields]) => {
              if (Array.isArray(fields)) {
                fields?.forEach((field: DischargeField) => {
                  if (!initialEditedFields[key]) {
                    initialEditedFields[key] = {};
                  }
                  initialEditedFields[key][field.id] = field.data ?? null;
                });
              }
            });
          });
        }
      });
      dispatch(
        updateField({
          sectionKey: "all",
          fieldId: "all",
          value: initialEditedFields,
        })
      );
      if (
        currentStep?.visitStage === "Discharge" &&
        currentVisitStage &&
        currentStep &&
        currentStep?.visitStageId &&
        currentVisitStage?.visitStageId &&
        (currentVisitStage?.state == null ||
          currentStep?.visitStageId > currentVisitStage?.visitStageId)
      ) {
        dispatch(setToggleEditMode(true));
      } else {
        dispatch(setToggleEditMode(false));
      }
    }

    // if (auth?.role?.role === "BO_STAFF") {
    //   if (
    //     preAuth?.stepperData?.currentVisitStage?.visitStage === "Discharge" &&
    //     preAuth?.stepperData?.currentVisitStage?.state === "Intimated"
    //   ) {
    //     // handleToggleEditMode();
    //     dispatch(setToggleEditMode(true));
    //   }
    // }
  }, [caseDischargeId, dischargeData]);

  useEffect(() => {
    if (dischargeData?.ihxDischargeResponses) {
      // Extract billing fields dynamically from the discharge data
      const extractedBillingFields = dischargeData.ihxDischargeResponses[0][
        "Billing Details"
      ]
        ?.filter((field: DischargeField) => field.id !== "totalAmount")
        ?.map((field: DischargeField) => field.id);
      setBillingFields(extractedBillingFields);
    }
  }, [dischargeData]);

  const handleToggleEditMode = () => {
    if (!editMode && dischargeData) {
      // Entering edit mode: initialize editedFields with current values
      const initialEditedFields: Record<string, Record<string, any>> = {};
      Object.keys(dischargeData)?.forEach((key) => {
        const sections = dischargeData[key as keyof DischargeResponse] as
          | DischargeSection[]
          | undefined;
        if (sections) {
          sections?.forEach((section) => {
            Object.entries(section)?.forEach(([sectionTitle, fields]) => {
              if (Array.isArray(fields)) {
                fields?.forEach((field: DischargeField) => {
                  if (!initialEditedFields[key]) {
                    initialEditedFields[key] = {};
                  }

                  if (
                    dischargeData?.cghsDischargeResponse ||
                    dischargeData?.starHealthDischargeResponse ||
                    dischargeData?.echsDischargeResponse
                  ) {
                    initialEditedFields[key][field.id] = field?.id
                      ?.toLowerCase()
                      ?.includes("date")
                      ? field?.data
                        ? dayjs(field?.data, "DD-MM-YYYY HH:mm:ss")
                        : null
                      : field?.data ?? null;
                  } else if (dischargeData?.ihxDischargeResponses) {
                    initialEditedFields[key][field.id] = field.data ?? "";
                  }
                });
              }
            });
          });
        }
      });
      dispatch(
        updateField({
          sectionKey: "all",
          fieldId: "all",
          value: initialEditedFields,
        })
      );
    }
    dispatch(toggleEditMode());
  };

  const viewFile = (file: any) => {
    window.open(file, "_blank");
  };

  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number
  ) => {
    const deleteDocument = uploadedDocumentUrl?.find(
      (doc, index) => doc?.documentUrl === documentUrl
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };
    const newUpdatedDocumentList = uploadedDocumentUrl?.filter(
      (doc, index) => doc?.documentUrl !== documentUrl
    );
    setUploadedDocumentUrl(newUpdatedDocumentList);

    if (deleteDocument?.documentUrl) {
      try {
        await dispatch(deleteUploadedDocument(deleteForm));
      } catch (err) {
        console.error(err);
      }
    }
    if (dischargeData?.cghsDischargeResponse) {
      const remainingDocsOfType = newUpdatedDocumentList?.filter(
        (doc) => doc.documentLabelType === documentType
      );
      if (remainingDocsOfType.length === 0) {
        dispatch(
          updateField({
            sectionKey: "cghsDischargeResponse",
            fieldId: documentType.split(" ").join("_"),
            value: "",
          })
        );
        dispatch(
          updateDischargeDataField({
            sectionKey: "cghsDischargeResponse",
            fieldId: documentType.split(" ").join("_"),
            updateValues: {
              data: "",
              documentName: "",
            },
          })
        );
      }
    } else if (dischargeData?.ihxDischargeResponses) {
      if (
        documentType?.toUpperCase() === "OTHERS" ||
        documentType?.toUpperCase() === "Discharge Summary"?.toUpperCase() ||
        documentType?.toUpperCase() === "Final Bill"?.toUpperCase() ||
        documentType?.toUpperCase() === "Invoice"?.toUpperCase() ||
        documentType?.toUpperCase() ===
          "Discharge Approval Letter"?.toUpperCase() ||
        documentType?.toUpperCase() === "Denial Letter"?.toUpperCase() ||
        documentType?.toUpperCase() === "Query letter"?.toUpperCase()
      ) {
        const hasDocument = newUpdatedDocumentList?.some(
          (doc) =>
            doc?.documentLabelType?.toUpperCase() ===
            documentType?.toUpperCase()
        );
        if (!hasDocument) {
          dispatch(
            updateField({
              sectionKey: "ihxDischargeResponses",
              fieldId: documentType?.split(" ").join("_"),
              value: "",
            })
          );
        }
      } else {
        dispatch(
          updateField({
            sectionKey: "ihxDischargeResponses",
            fieldId: documentType?.split(" ").join("_"),
            value: "",
          })
        );
      }
    }
  };

  useEffect(() => {
    if (
      dischargeData?.cghsDischargeResponse &&
      editedFields["cghsDischargeResponse"]?.treatingDoctorType &&
      (discharge?.selectedScheme?.schemeMetaDataName?.toUpperCase() ===
        "CGHS" ||
        discharge?.selectedScheme?.schemeMetaDataName?.toUpperCase() === "CAPF")
    ) {
      const data = {
        docType: editedFields["cghsDischargeResponse"]?.treatingDoctorType,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: discharge?.selectedScheme?.schemeMetaDataId,
      };
      dispatch(fetchDoctorTypeList(data));
    } else if (
      dischargeData?.starHealthDischargeResponse &&
      discharge?.selectedScheme?.portalMetaDataIdsList[0]
    ) {
      dispatch(
        fetchStarHealthRoomTypeList(
          discharge?.selectedScheme?.portalMetaDataIdsList[0]
        )
      );
    }
  }, [
    dischargeData,
    dischargeData?.starHealthDischargeResponse,
    discharge?.selectedScheme?.portalMetaDataIdsList,
    dischargeData?.cghsDischargeResponse,
    editedFields,
    discharge?.selectedScheme?.schemeMetaDataId,
    patients?.fetchBasicDetails?.casesResponse?.healthCareId,
  ]);

  const handleFieldChange = (
    sectionKey: string,
    fieldId: string,
    value: string
  ) => {
    if (fieldId?.toLowerCase()?.includes("date")) {
      dispatch(
        updateField({
          sectionKey,
          fieldId,
          value: dayjs(value, "DD-MM-YYYY HH:mm:ss"),
        })
      );
    } else if (fieldId === "treatingDoctorName") {
      dispatch(
        updateField({ sectionKey, fieldId, value: value?.split("~")[0] })
      );
      dispatch(
        updateField({
          sectionKey,
          fieldId: "treatingDoctorRegistrationNo",
          value: value?.split("~")[1],
        })
      );
      dispatch(
        updateField({
          sectionKey,
          fieldId: "treatingDoctorContactNumber",
          value: value?.split("~")[2] !== "null" ? value?.split("~")[2] : "",
        })
      );
      dispatch(
        updateField({
          sectionKey,
          fieldId: "treatingDoctorQualification",
          value: value?.split("~")[3],
        })
      );
    } else {
      dispatch(updateField({ sectionKey, fieldId, value }));
    }

    // Recalculate total if it's a billing field
    if (sectionKey === "ihxDischargeResponses" && fieldId !== "totalAmount") {
      const currentValues = editedFields[sectionKey] || {};
      const newValues = { ...currentValues, [fieldId]: value };

      const total = billingFields.reduce((sum, field) => {
        const fieldValue = parseFloat(newValues[field]) || 0;
        return sum + fieldValue;
      }, 0);

      dispatch(
        updateField({
          sectionKey,
          fieldId: "totalAmount",
          value: total.toFixed(2),
        })
      );
    }
  };

  // useEffect(() => {
  //   if (dischargeData?.cghsDischargeResponse) {
  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsDischargeResponse",
  //         fieldId: "dischargeSummaryTreatmentGiven",
  //         value: discharge?.dischargeSummaryResponse?.treatmentGiven,
  //       })
  //     );

  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsDischargeResponse",
  //         fieldId: "dischargeSummaryOperativeFindings",
  //         value: discharge?.dischargeSummaryResponse?.operativeFindings,
  //       })
  //     );

  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsDischargeResponse",
  //         fieldId: "dischargeSummaryPostOperativeMethod",
  //         value: discharge?.dischargeSummaryResponse?.postOperativePeriod,
  //       })
  //     );

  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsDischargeResponse",
  //         fieldId: "dischargeSummaryPostSurgery",
  //         value: discharge?.dischargeSummaryResponse?.specialInvestiation,
  //       })
  //     );

  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsDischargeResponse",
  //         fieldId: "statusAtTimeOfDischarge",
  //         value: discharge?.dischargeSummaryResponse?.statusAtDischarge,
  //       })
  //     );

  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsDischargeResponse",
  //         fieldId: "dischargeSummaryReview",
  //         value: discharge?.dischargeSummaryResponse?.review,
  //       })
  //     );

  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsDischargeResponse",
  //         fieldId: "dischargeSummaryAdvice",
  //         value: discharge?.dischargeSummaryResponse?.advice,
  //       })
  //     );

  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsDischargeResponse",
  //         fieldId: "covidPatientOrNot",
  //         value: discharge?.dischargeSummaryResponse?.covidCase || dischargeData?.cghsDischargeResponse?.[0]?.["COVID Case Details"]?.[0]?.data,
  //       })
  //     );

  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsDischargeResponse",
  //         fieldId: "radioButtonForDischargeAndDeath",
  //         value: discharge?.dischargeSummaryResponse?.dischargeOrDeath,
  //       })
  //     );

  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsDischargeResponse",
  //         fieldId: "surgeryDate",
  //         value: discharge?.dischargeSummaryResponse?.startDate || dischargeData?.cghsDischargeResponse?.[0]?.["Treatment/Surgery Date"]?.[0]?.data,
  //       })
  //     );

  //     dispatch(
  //       updateField({
  //         sectionKey: "cghsDischargeResponse",
  //         fieldId: "treatingDoctorType",
  //         value: "O",
  //       })
  //     );
  //   }
  // }, [dischargeData, discharge?.dischargeSummaryResponse]);

  useEffect(() => {
    if (
      dischargeData?.cghsDischargeResponse &&
      discharge?.dischargeSummaryResponse?.name &&
      !discharge?.editedFields?.cghsDischargeResponse?.treatingDoctorName
    ) {
      const doctorPresent = discharge?.doctorTypeList?.find((doctor: any) =>
        doctor?.docName
          ?.toLowerCase()
          ?.includes(discharge?.dischargeSummaryResponse?.name?.toLowerCase())
      );

      if (
        !doctorPresent &&
        discharge?.activeStep === 2 &&
        !discharge?.editedFields?.cghsDischargeResponse?.treatingDoctorName
      ) {
        errorMessage("Doctor is not Found. Please, select doctor manually");
      } else {
        dispatch(
          updateField({
            sectionKey: "cghsDischargeResponse",
            fieldId: "treatingDoctorName",
            value: doctorPresent?.docName,
          })
        );
        dispatch(
          updateField({
            sectionKey: "cghsDischargeResponse",
            fieldId: "treatingDoctorRegistrationNo",
            value: doctorPresent?.docRegn,
          })
        );
        dispatch(
          updateField({
            sectionKey: "cghsDischargeResponse",
            fieldId: "treatingDoctorContactNumber",
            value: doctorPresent?.docMobile || null,
          })
        );
        dispatch(
          updateField({
            sectionKey: "cghsDischargeResponse",
            fieldId: "treatingDoctorQualification",
            value: doctorPresent?.docQualification,
          })
        );
      }
    }
  }, [
    dischargeData,
    discharge?.activeStep,
    dischargeData,
    discharge?.dischargeSummaryResponse,
  ]);

  const updateOrAddDocument = (
    uploadedDocumentUrl: Array<IDocumentFields>,
    documentRes: IDocumentFields
  ): Array<IDocumentFields> => {
    if (
      dischargeData?.ihxDischargeResponses ||
      dischargeData?.starHealthDischargeResponse ||
      dischargeData?.echsDischargeResponse
    ) {
      const updatedDocuments = [...uploadedDocumentUrl];
      const documentIndex = updatedDocuments.findIndex(
        (doc) => doc?.documentType === documentRes?.documentType
      );

      if (
        documentIndex !== -1 &&
        dischargeData?.ihxDischargeResponses &&
        documentRes?.documentLabelType?.toUpperCase() !== "OTHERS" &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "Discharge Summary"?.toUpperCase() &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "Final Bill"?.toUpperCase() &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "Invoice"?.toUpperCase() &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "Discharge Approval Letter"?.toUpperCase() &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "Denial Letter"?.toUpperCase() &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "Query letter"?.toUpperCase()
      ) {
        updatedDocuments[documentIndex] = {
          ...updatedDocuments[documentIndex],
          documentName: documentRes?.documentName,
          documentUrl: documentRes?.documentUrl,
          deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
          id: documentRes?.id,
        };
      } else if (
        documentIndex !== -1 &&
        !dischargeData?.ihxDischargeResponses
      ) {
        updatedDocuments[documentIndex] = {
          ...updatedDocuments[documentIndex],
          documentName: documentRes?.documentName,
          documentUrl: documentRes?.documentUrl,
          deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
          id: documentRes?.id,
        };
      } else {
        updatedDocuments.push({
          documentType: documentRes?.documentType,
          documentName: documentRes?.documentName,
          documentUrl: documentRes?.documentUrl,
          documentLabelType: documentRes?.documentLabelType,
          id: documentRes?.id,
          deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        });
      }

      // Return the updated array (ensures it's a flat array)
      return updatedDocuments;
    } else {
      const updatedDocuments = [...uploadedDocumentUrl];
      const documentIndex = updatedDocuments.findIndex(
        (doc) => doc?.documentType === documentRes?.documentType
      );

      if (documentIndex !== -1) {
        updatedDocuments[documentIndex] = {
          ...updatedDocuments[documentIndex],
          documentName: documentRes?.documentName,
          documentUrl: documentRes?.documentUrl,
          deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
          id: documentRes?.id,
        };
      } else {
        updatedDocuments.push({
          documentType: documentRes?.documentType,
          documentName: documentRes?.documentName,
          documentUrl: documentRes?.documentUrl,
          documentLabelType: documentRes?.documentLabelType,
          id: documentRes?.id,
          deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        });
      }

      // Return the updated array (ensures it's a flat array)
      return updatedDocuments;
    }
  };

  const handleUpload = async () => {
    const CollectPostData = new FormData();
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
      );
    }
    if (getIds?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        getIds?.fetchBasicDetails?.patientResponse?.id?.toString()
      );
    }
    if (getIds?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        getIds?.fetchBasicDetails?.casesResponse?.id?.toString()
      );
    }
    if (getIds?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        getIds?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
      );
    }
    CollectPostData.append("documentType", previewFile.documentType);

    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file);
    }

    try {
      const documentRes = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        })
      ).unwrap();

      if (
        documentRes?.documentLabelType === "DISCHARGE SUMMARY" &&
        (dischargeData?.cghsDischargeResponse ||
          dischargeData?.echsDischargeResponse)
      ) {
        // const formData = {
        //   DSPath: documentRes?.documentUrl,
        // };
        // await dispatch(dischargeSummaryReaderResponse(formData));
        setDSPath(documentRes?.documentUrl);
      }
      const updatedDocuments = updateOrAddDocument(
        uploadedDocumentUrl,
        documentRes
      );

      setUploadedDocumentUrl(updatedDocuments);
      setPreviewModalVisible(false);
      message.success(
        `${documentRes?.documentLabelType} uploaded successfully`
      );
    } catch (error) {
      console.error("Failed to upload document:", error);
    }
  };

  const handleSaveChanges = async () => {
    setIsSubmitted(true);
    try {
      let dataToSave: any = {};
      if (dischargeData?.ihxDischargeResponses) {
        dataToSave = {
          dateOfAdmission: dischargeData?.ihxDischargeResponses?.[0]?.[
            "Basic Details"
          ]?.find((field: DischargeField) => field.id === "dateOfAdmission")
            ?.data,
        };

        Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
          Object.entries(fields)?.forEach(([fieldId, value]) => {
            if (
              fieldId === "dateOfDischarge" ||
              fieldId === "dateOfAdmission"
            ) {
              const regex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
              if (
                regex.test(value) &&
                dayjs(value, "DD-MM-YYYY HH:mm:ss", true).isValid()
              ) {
                if (fieldId === "dateOfDischarge")
                  dataToSave.dateOfDischarge = value;
                else if (fieldId === "dateOfAdmission")
                  dataToSave.dateOfAdmission = value;
              } else {
                const parsedDate = dayjs(value);
                if (fieldId === "dateOfDischarge") {
                  dataToSave.dateOfDischarge = parsedDate.isValid()
                    ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                    : null;
                } else if (fieldId === "dateOfAdmission") {
                  dataToSave.dateOfAdmission = parsedDate.isValid()
                    ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                    : null;
                }
              }
            } else if (fieldId === "radioButtonForDischargeAndDeath") {
              if (value === "true") {
                delete dataToSave[fieldId];
                dataToSave["death"] = true;
                dataToSave["discharge"] = false;
              } else if (value === "false") {
                delete dataToSave[fieldId];
                dataToSave["discharge"] = true;
                dataToSave["death"] = false;
              }
            } else {
              dataToSave[fieldId] =
                value === "true" ? true : value === "false" ? false : value;
            }
          });
        });

        if (uploadedDocumentUrl) {
          dataToSave.documentUrls = uploadedDocumentUrl;
        }
      } else if (dischargeData?.cghsDischargeResponse) {
        Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
          Object.entries(fields)?.forEach(([fieldId, value]) => {
            if (value === "true") {
              dataToSave[fieldId] = true;
            } else if (value === "false") {
              dataToSave[fieldId] = false;
            } else if (fieldId?.toLowerCase()?.includes("date")) {
              dataToSave[fieldId] =
                value === "" || value === null
                  ? null
                  : dayjs(value).format("DD-MM-YYYY HH:mm:ss");
            }
            if (fieldId === "radioButtonForDischargeAndDeath") {
              if (value === "death") {
                delete dataToSave[fieldId];
                dataToSave["death"] = true;
                dataToSave["discharge"] = false;
              } else if (value === "discharge") {
                delete dataToSave[fieldId];
                dataToSave["discharge"] = true;
                dataToSave["death"] = false;
              }
            } else {
              dataToSave[fieldId] =
                value === "" || value === null ? null : value;
            }

            if (fieldId === "surgeryDate" || fieldId === "dateOfDischarge") {
              dataToSave[fieldId] =
                value === "" || value === null
                  ? null
                  : dayjs(value, "DD-MM-YYYY HH:mm:ss").format(
                      "DD-MM-YYYY HH:mm:ss"
                    );
            }
            if (fieldId?.toLowerCase()?.includes("date")) {
              dataToSave[fieldId] =
                value === "" || value === null
                  ? null
                  : dayjs(value, "DD-MM-YYYY HH:mm:ss").format(
                      "DD-MM-YYYY HH:mm:ss"
                    );
            }
          });
        });

        dataToSave["dateOfAdmission"] = null;

        if (uploadedDocumentUrl) {
          dataToSave.documentUrls = uploadedDocumentUrl;
        }
      } else if (dischargeData?.starHealthDischargeResponse) {
        dataToSave = {
          dateOfAdmission: dischargeData?.starHealthDischargeResponse?.[0]?.[
            "Basic Details"
          ]?.find((field: DischargeField) => field.id === "dateOfAdmission")
            ?.data,
        };

        Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
          Object.entries(fields)?.forEach(([fieldId, value]) => {
            if (
              fieldId === "dateOfDischarge" ||
              fieldId === "dateOfAdmission" ||
              fieldId?.toLowerCase()?.includes("date")
            ) {
              const regex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
              if (
                regex.test(value) &&
                dayjs(value, "DD-MM-YYYY HH:mm:ss", true).isValid()
              ) {
                dataToSave[fieldId] = value;
              } else {
                const parsedDate = dayjs(value);
                dataToSave[fieldId] = parsedDate.isValid()
                  ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                  : null;
              }
            } else if (fieldId === "roomType") {
              const id = value?.includes("~")
                ? value?.split("~")[0]
                : value?.split(":")[0];
              const roomType = value?.includes("~")
                ? value?.split("~")[1]
                : value?.split(":")[1];
              dataToSave[fieldId] = { id, name: roomType };
            } else {
              dataToSave[fieldId] =
                value === "true" ? true : value === "false" ? false : value;
            }
          });
        });

        if (uploadedDocumentUrl) {
          dataToSave.documentUrls = uploadedDocumentUrl;
        }
      } else if (dischargeData?.echsDischargeResponse) {
        dataToSave = {
          dateOfAdmission: dischargeData?.echsDischargeResponse?.[0]?.[
            "Basic Details"
          ]?.find((field: DischargeField) => field.id === "dateOfAdmission")
            ?.data,
        };

        Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
          Object.entries(fields)?.forEach(([fieldId, value]) => {
            if (
              fieldId === "dateOfDischarge" ||
              fieldId === "dateOfAdmission" ||
              fieldId?.toLowerCase()?.includes("date")
            ) {
              const regex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
              if (
                regex.test(value) &&
                dayjs(value, "DD-MM-YYYY HH:mm:ss", true).isValid()
              ) {
                dataToSave[fieldId] = value;
              } else {
                const parsedDate = dayjs(value);
                dataToSave[fieldId] = parsedDate.isValid()
                  ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                  : null;
              }
            } else if (fieldId === "roomType") {
              dataToSave[fieldId] = { id: null, name: value };
            } else {
              dataToSave[fieldId] =
                value === "true" ? true : value === "false" ? false : value;
            }
          });
        });

        if (uploadedDocumentUrl) {
          dataToSave.documentUrls = uploadedDocumentUrl;
        }
      }

      const resp = await dispatch(
        submitDischargeData({
          caseId: getIds?.fetchBasicDetails?.casesResponse?.id,
          visitId: getIds?.fetchBasicDetails?.visitInfoResponse?.id,
          portalMetaDataId: discharge?.selectedScheme?.portalMetaDataIdsList[0],
          caseDischargeId,
          dischargeData: {
            ...dataToSave,
            hospitalId:
              patients?.fetchBasicDetails?.casesResponse?.healthCareId,
            schemeId: discharge?.selectedScheme?.schemeMetaDataId,
          },
        })
      );

      if (submitDischargeData.fulfilled.match(resp)) {
        // if (caseDischargeId === null) {
        setIsFetchingDischargeData(true);
        const newData = await dischargeService.getDischargeData(
          getIds?.fetchBasicDetails?.casesResponse?.id,
          getIds?.fetchBasicDetails?.visitInfoResponse?.id,
          discharge?.selectedScheme?.portalMetaDataIdsList[0]
        );
        // onfetchStepper();
        setIsFetchingDischargeData(false);
        getAttachmentsWithValues(newData);
        dispatch(setDischargeDataSuccess(newData));
        if (newData?.ihxDischargeResponses) {
          // Update Discharge Id with the new value
          const newCaseDischargeId =
            newData?.ihxDischargeResponses?.[0]?.["Basic Details"]?.[0]
              ?.caseDischargeId;
          if (newCaseDischargeId) {
            setCaseDischargeId(newCaseDischargeId);
          }
          const portalSubmitCheck =
            newData?.ihxDischargeResponses?.[0]?.["Basic Details"]?.[0]?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
        } else if (newData?.cghsDischargeResponse) {
          // Update Discharge Id with the new value
          const newCaseDischargeId =
            newData?.cghsDischargeResponse?.[0]?.["Discharge"]?.[0]
              ?.caseDischargeId;
          if (newCaseDischargeId) {
            setCaseDischargeId(newCaseDischargeId);
          }
          const portalSubmitCheck =
            newData?.cghsDischargeResponse?.[0]?.["Discharge"]?.[0]?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
        } else if (newData?.starHealthDischargeResponse) {
          // Update Discharge Id with the new value
          const newCaseDischargeId =
            newData?.starHealthDischargeResponse?.[0]?.["Basic Details"]?.[0]
              ?.caseDischargeId;
          if (newCaseDischargeId) {
            setCaseDischargeId(newCaseDischargeId);
          }
          const portalSubmitCheck =
            newData?.starHealthDischargeResponse?.[0]?.["Basic Details"]?.[0]
              ?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
        } else if (newData?.echsDischargeResponse) {
          // Update Discharge Id with the new value
          const newCaseDischargeId =
            newData?.echsDischargeResponse?.[0]?.["Basic Details"]?.[0]
              ?.caseDischargeId;
          if (newCaseDischargeId) {
            setCaseDischargeId(newCaseDischargeId);
          }

          const portalSubmitCheck =
            newData?.echsDischargeResponse?.[0]?.["Basic Details"]?.[0]?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
        }

        // }

        dispatch(saveChanges());
        // dispatch(clearUploadedDocumentUrlsAfterSave());
        // setUploadedDocumentUrl([]);

        if (dischargeData) {
          const updatedDischargeData = JSON.parse(
            JSON.stringify(dischargeData)
          );
          Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
            const section =
              updatedDischargeData[sectionKey as keyof DischargeResponse];
            if (Array.isArray(section)) {
              section?.forEach((sectionData) => {
                Object.entries(fields)?.forEach(([fieldId, value]) => {
                  const fieldIndex = sectionData[
                    Object.keys(sectionData)[0]
                  ].findIndex((f: DischargeField) => f.id === fieldId);
                  if (fieldIndex !== -1) {
                    sectionData[Object.keys(sectionData)[0]][fieldIndex] = {
                      ...sectionData[Object.keys(sectionData)[0]][fieldIndex],
                      data:
                        value === "true"
                          ? true
                          : value === "false"
                          ? false
                          : value,
                    };
                  }
                });
              });
            }
          });

          // Update the documentUrls in the dischargeData
          if (uploadedDocumentUrl.length > 0) {
            updatedDischargeData.documentUrls = uploadedDocumentUrl;
          }

          dispatch(setDischargeDataSuccess(updatedDischargeData));
          getAttachmentsWithValues(updatedDischargeData);
          if (caseDischargeId) {
            setIsFetchingDischargeData(true);
            const newData = await dischargeService.getDischargeData(
              getIds?.fetchBasicDetails?.casesResponse?.id,
              getIds?.fetchBasicDetails?.visitInfoResponse?.id,
              discharge?.selectedScheme?.portalMetaDataIdsList[0]
            );
            // onfetchStepper();
            setIsFetchingDischargeData(false);
            getAttachmentsWithValues(newData);
            dispatch(setDischargeDataSuccess(newData));

            if (newData?.ihxDischargeResponses) {
              // Update Discharge Id with the new value
              const newCaseDischargeId =
                newData?.ihxDischargeResponses?.[0]?.["Basic Details"]?.[0]
                  ?.caseDischargeId;
              if (newCaseDischargeId) {
                setCaseDischargeId(newCaseDischargeId);
              }
              const portalSubmitCheck =
                newData?.ihxDischargeResponses?.[0]?.["Basic Details"]?.[0]
                  ?.status;
              if (portalSubmitCheck) {
                setPortalSubmission(portalSubmitCheck);
              }
            } else if (newData?.cghsDischargeResponse) {
              // Update Discharge Id with the new value
              const newCaseDischargeId =
                newData?.cghsDischargeResponse?.[0]?.["Discharge"]?.[0]
                  ?.caseDischargeId;
              if (newCaseDischargeId) {
                setCaseDischargeId(newCaseDischargeId);
              }
              const portalSubmitCheck =
                newData?.cghsDischargeResponse?.[0]?.["Discharge"]?.[0]?.status;
              if (portalSubmitCheck) {
                setPortalSubmission(portalSubmitCheck);
              }
            } else if (newData?.starHealthDischargeResponse) {
              // Update Discharge Id with the new value
              const newCaseDischargeId =
                newData?.starHealthDischargeResponse?.[0]?.[
                  "Basic Details"
                ]?.[0]?.caseDischargeId;
              if (newCaseDischargeId) {
                setCaseDischargeId(newCaseDischargeId);
              }

              const portalSubmitCheck =
                newData?.starHealthDischargeResponse?.[0]?.[
                  "Basic Details"
                ]?.[0]?.status;
              if (portalSubmitCheck) {
                setPortalSubmission(portalSubmitCheck);
              }
            } else if (newData?.echsDischargeResponse) {
              // Update Discharge Id with the new value
              const newCaseDischargeId =
                newData?.echsDischargeResponse?.[0]?.["Basic Details"]?.[0]
                  ?.caseDischargeId;
              if (newCaseDischargeId) {
                setCaseDischargeId(newCaseDischargeId);
              }

              const portalSubmitCheck =
                newData?.echsDischargeResponse?.[0]?.["Basic Details"]?.[0]
                  ?.status;
              if (portalSubmitCheck) {
                setPortalSubmission(portalSubmitCheck);
              }
            }

            onfetchStepper();
          }
        }
      }
      onfetchStepper();
      dispatch(toggleEditMode());
      message.success("Discharge Submitted Successfully");
    } catch (error: any) {
      if (
        error?.response?.status === 422 &&
        (error?.response?.data ||
          error?.response?.data
            ?.toLowerCase()
            ?.includes("case discharge is already submitted on portal"))
      ) {
        message.error(error?.response?.data);
        // dispatch(toggleEditMode());
        setIsSubmitted(false);
      } else {
        console.error("Failed to save changes:", error);
        message.error("Failed to save changes. Please try again.");
        setIsSubmitted(false);
      }

      setIsFetchingDischargeData(false);
    }
  };
  const handleSaveChangesInEdgePro = async () => {
    setIsSubmitted(true);
    try {
      let dataToSave: any = {};
      if (dischargeData?.ihxDischargeResponses) {
        dataToSave = {
          dateOfAdmission: dischargeData?.ihxDischargeResponses?.[0]?.[
            "Basic Details"
          ]?.find((field: DischargeField) => field.id === "dateOfAdmission")
            ?.data,
        };

        Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
          Object.entries(fields)?.forEach(([fieldId, value]) => {
            if (
              fieldId === "dateOfDischarge" ||
              fieldId === "dateOfAdmission"
            ) {
              const regex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
              if (
                regex.test(value) &&
                dayjs(value, "DD-MM-YYYY HH:mm:ss", true).isValid()
              ) {
                if (fieldId === "dateOfDischarge")
                  dataToSave.dateOfDischarge = value;
                else if (fieldId === "dateOfAdmission")
                  dataToSave.dateOfAdmission = value;
              } else {
                const parsedDate = dayjs(value);
                if (fieldId === "dateOfDischarge") {
                  dataToSave.dateOfDischarge = parsedDate.isValid()
                    ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                    : null;
                } else if (fieldId === "dateOfAdmission") {
                  dataToSave.dateOfAdmission = parsedDate.isValid()
                    ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                    : null;
                }
              }
            } else if (fieldId === "radioButtonForDischargeAndDeath") {
              if (value === "true") {
                delete dataToSave[fieldId];
                dataToSave["death"] = true;
                dataToSave["discharge"] = false;
              } else if (value === "false") {
                delete dataToSave[fieldId];
                dataToSave["discharge"] = true;
                dataToSave["death"] = false;
              }
            } else {
              dataToSave[fieldId] =
                value === "true" ? true : value === "false" ? false : value;
            }
          });
        });

        if (uploadedDocumentUrl) {
          dataToSave.documentUrls = uploadedDocumentUrl;
        }
      } else if (dischargeData?.cghsDischargeResponse) {
        Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
          Object.entries(fields)?.forEach(([fieldId, value]) => {
            if (value === "true") {
              dataToSave[fieldId] = true;
            } else if (value === "false") {
              dataToSave[fieldId] = false;
            } else if (fieldId?.toLowerCase()?.includes("date")) {
              dataToSave[fieldId] =
                value === "" || value === null
                  ? null
                  : dayjs(value).format("DD-MM-YYYY HH:mm:ss");
            }
            if (fieldId === "radioButtonForDischargeAndDeath") {
              if (value === "death") {
                delete dataToSave[fieldId];
                dataToSave["death"] = true;
                dataToSave["discharge"] = false;
              } else if (value === "discharge") {
                delete dataToSave[fieldId];
                dataToSave["discharge"] = true;
                dataToSave["death"] = false;
              }
            } else {
              dataToSave[fieldId] =
                value === "" || value === null ? null : value;
            }

            if (fieldId === "surgeryDate" || fieldId === "dateOfDischarge") {
              dataToSave[fieldId] =
                value === "" || value === null
                  ? null
                  : dayjs(value, "DD-MM-YYYY HH:mm:ss").format(
                      "DD-MM-YYYY HH:mm:ss"
                    );
            }

            if (fieldId?.toLowerCase()?.includes("date")) {
              dataToSave[fieldId] =
                value === "" || value === null
                  ? null
                  : dayjs(value, "DD-MM-YYYY HH:mm:ss").format(
                      "DD-MM-YYYY HH:mm:ss"
                    );
            }
          });
        });

        dataToSave["dateOfAdmission"] = null;

        if (uploadedDocumentUrl) {
          dataToSave.documentUrls = uploadedDocumentUrl;
        }
      } else if (dischargeData?.starHealthDischargeResponse) {
        dataToSave = {
          dateOfAdmission: dischargeData?.starHealthDischargeResponse?.[0]?.[
            "Basic Details"
          ]?.find((field: DischargeField) => field.id === "dateOfAdmission")
            ?.data,
        };

        Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
          Object.entries(fields)?.forEach(([fieldId, value]) => {
            if (
              fieldId === "dateOfDischarge" ||
              fieldId === "dateOfAdmission" ||
              fieldId?.toLowerCase()?.includes("date")
            ) {
              const regex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
              if (
                regex.test(value) &&
                dayjs(value, "DD-MM-YYYY HH:mm:ss", true).isValid()
              ) {
                dataToSave[fieldId] = value;
              } else {
                const parsedDate = dayjs(value);
                dataToSave[fieldId] = parsedDate.isValid()
                  ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                  : null;
              }
            } else if (fieldId === "roomType") {
              const id = value?.includes("~")
                ? value?.split("~")[0]
                : value?.split(":")[0];
              const roomType = value?.includes("~")
                ? value?.split("~")[1]
                : value?.split(":")[1];
              dataToSave[fieldId] = { id, name: roomType };
            } else {
              dataToSave[fieldId] =
                value === "true" ? true : value === "false" ? false : value;
            }
          });
        });

        if (uploadedDocumentUrl) {
          dataToSave.documentUrls = uploadedDocumentUrl;
        }
      } else if (dischargeData?.echsDischargeResponse) {
        dataToSave = {
          dateOfAdmission: dischargeData?.echsDischargeResponse?.[0]?.[
            "Basic Details"
          ]?.find((field: DischargeField) => field.id === "dateOfAdmission")
            ?.data,
        };

        Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
          Object.entries(fields)?.forEach(([fieldId, value]) => {
            if (
              fieldId === "dateOfDischarge" ||
              fieldId === "dateOfAdmission" ||
              fieldId?.toLowerCase()?.includes("date")
            ) {
              const regex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
              if (
                regex.test(value) &&
                dayjs(value, "DD-MM-YYYY HH:mm:ss", true).isValid()
              ) {
                dataToSave[fieldId] = value;
              } else {
                const parsedDate = dayjs(value);
                dataToSave[fieldId] = parsedDate.isValid()
                  ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                  : null;
              }
            } else if (fieldId === "roomType") {
              dataToSave[fieldId] = { id: null, name: value };
            } else {
              dataToSave[fieldId] =
                value === "true" ? true : value === "false" ? false : value;
            }
          });
        });

        if (uploadedDocumentUrl) {
          dataToSave.documentUrls = uploadedDocumentUrl;
        }
      }

      await dispatch(
        submitDischargeDataInEdgePro({
          caseId: getIds?.fetchBasicDetails?.casesResponse?.id,
          visitId: getIds?.fetchBasicDetails?.visitInfoResponse?.id,
          portalMetaDataId: discharge?.selectedScheme?.portalMetaDataIdsList[0],
          caseDischargeId,
          dischargeData: {
            ...dataToSave,
            hospitalId:
              patients?.fetchBasicDetails?.casesResponse?.healthCareId,
            schemeId: discharge?.selectedScheme?.schemeMetaDataId,
          },
        })
      ).unwrap();

      if (caseDischargeId === null) {
        setIsFetchingDischargeData(true);
        const newData = await dischargeService.getDischargeData(
          getIds?.fetchBasicDetails?.casesResponse?.id,
          getIds?.fetchBasicDetails?.visitInfoResponse?.id,
          discharge?.selectedScheme?.portalMetaDataIdsList[0]
        );
        // onfetchStepper();
        setIsFetchingDischargeData(false);
        getAttachmentsWithValues(newData);
        dispatch(setDischargeDataSuccess(newData));
        if (newData?.ihxDischargeResponses) {
          // Update Discharge Id with the new value
          const newCaseDischargeId =
            newData?.ihxDischargeResponses?.[0]?.["Basic Details"]?.[0]
              ?.caseDischargeId;
          if (newCaseDischargeId) {
            setCaseDischargeId(newCaseDischargeId);
          }
          const portalSubmitCheck =
            newData?.ihxDischargeResponses?.[0]?.["Basic Details"]?.[0]?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
        } else if (newData?.cghsDischargeResponse) {
          // Update Discharge Id with the new value
          const newCaseDischargeId =
            newData?.cghsDischargeResponse?.[0]?.["Discharge"]?.[0]
              ?.caseDischargeId;
          if (newCaseDischargeId) {
            setCaseDischargeId(newCaseDischargeId);
          }
          const portalSubmitCheck =
            newData?.cghsDischargeResponse?.[0]?.["Discharge"]?.[0]?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
        } else if (newData?.starHealthDischargeResponse) {
          // Update Discharge Id with the new value
          const newCaseDischargeId =
            newData?.starHealthDischargeResponse?.[0]?.["Basic Details"]?.[0]
              ?.caseDischargeId;
          if (newCaseDischargeId) {
            setCaseDischargeId(newCaseDischargeId);
          }

          const portalSubmitCheck =
            newData?.starHealthDischargeResponse?.[0]?.["Basic Details"]?.[0]
              ?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
        } else if (newData?.echsDischargeResponse) {
          // Update Discharge Id with the new value
          const newCaseDischargeId =
            newData?.echsDischargeResponse?.[0]?.["Basic Details"]?.[0]
              ?.caseDischargeId;
          if (newCaseDischargeId) {
            setCaseDischargeId(newCaseDischargeId);
          }

          const portalSubmitCheck =
            newData?.echsDischargeResponse?.[0]?.["Basic Details"]?.[0]?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
        }

        onfetchStepper();
      }

      dispatch(saveChanges());
      dispatch(clearUploadedDocumentUrlsAfterSave());
      setUploadedDocumentUrl([]);

      if (dischargeData) {
        const updatedDischargeData = JSON.parse(JSON.stringify(dischargeData));
        Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
          const section =
            updatedDischargeData[sectionKey as keyof DischargeResponse];
          if (Array.isArray(section)) {
            section?.forEach((sectionData) => {
              Object.entries(fields)?.forEach(([fieldId, value]) => {
                const fieldIndex = sectionData[
                  Object.keys(sectionData)[0]
                ].findIndex((f: DischargeField) => f.id === fieldId);
                if (fieldIndex !== -1) {
                  sectionData[Object.keys(sectionData)[0]][fieldIndex] = {
                    ...sectionData[Object.keys(sectionData)[0]][fieldIndex],
                    data:
                      value === "true"
                        ? true
                        : value === "false"
                        ? false
                        : value,
                  };
                }
              });
            });
          }
        });

        // Update the documentUrls in the dischargeData
        if (uploadedDocumentUrl.length > 0) {
          updatedDischargeData.documentUrls = uploadedDocumentUrl;
        }

        dispatch(setDischargeDataSuccess(updatedDischargeData));
        getAttachmentsWithValues(updatedDischargeData);
        if (caseDischargeId) {
          setIsFetchingDischargeData(true);
          const newData = await dischargeService.getDischargeData(
            getIds?.fetchBasicDetails?.casesResponse?.id,
            getIds?.fetchBasicDetails?.visitInfoResponse?.id,
            discharge?.selectedScheme?.portalMetaDataIdsList[0]
          );
          setIsFetchingDischargeData(false);
          getAttachmentsWithValues(newData);
          dispatch(setDischargeDataSuccess(newData));

          if (newData?.ihxDischargeResponses) {
            // Update Discharge Id with the new value
            const newCaseDischargeId =
              newData?.ihxDischargeResponses?.[0]?.["Basic Details"]?.[0]
                ?.caseDischargeId;
            if (newCaseDischargeId) {
              setCaseDischargeId(newCaseDischargeId);
            }
            const portalSubmitCheck =
              newData?.ihxDischargeResponses?.[0]?.["Basic Details"]?.[0]
                ?.status;
            if (portalSubmitCheck) {
              setPortalSubmission(portalSubmitCheck);
            }
          } else if (newData?.cghsDischargeResponse) {
            // Update Discharge Id with the new value
            const newCaseDischargeId =
              newData?.cghsDischargeResponse?.[0]?.["Discharge"]?.[0]
                ?.caseDischargeId;
            if (newCaseDischargeId) {
              setCaseDischargeId(newCaseDischargeId);
            }
            const portalSubmitCheck =
              newData?.cghsDischargeResponse?.[0]?.["Discharge"]?.[0]?.status;
            if (portalSubmitCheck) {
              setPortalSubmission(portalSubmitCheck);
            }
          } else if (newData?.starHealthDischargeResponse) {
            // Update Discharge Id with the new value
            const newCaseDischargeId =
              newData?.starHealthDischargeResponse?.[0]?.["Basic Details"]?.[0]
                ?.caseDischargeId;
            if (newCaseDischargeId) {
              setCaseDischargeId(newCaseDischargeId);
            }

            const portalSubmitCheck =
              newData?.starHealthDischargeResponse?.[0]?.["Basic Details"]?.[0]
                ?.status;
            if (portalSubmitCheck) {
              setPortalSubmission(portalSubmitCheck);
            }
          } else if (newData?.echsDischargeResponse) {
            // Update Discharge Id with the new value
            const newCaseDischargeId =
              newData?.echsDischargeResponse?.[0]?.["Basic Details"]?.[0]
                ?.caseDischargeId;
            if (newCaseDischargeId) {
              setCaseDischargeId(newCaseDischargeId);
            }

            const portalSubmitCheck =
              newData?.echsDischargeResponse?.[0]?.["Basic Details"]?.[0]
                ?.status;
            if (portalSubmitCheck) {
              setPortalSubmission(portalSubmitCheck);
            }
          }

          onfetchStepper();
        }
      }

      message.success("Changes saved successfully");
    } catch (error: any) {
      if (
        error?.response?.status === 422 &&
        error?.response?.data &&
        error?.response?.data
          ?.toLowerCase()
          ?.includes("case discharge is already submitted on portal")
      ) {
        message.error(
          "Case Discharges submitted on portal we can't update it."
        );
        dispatch(toggleEditMode());
        setIsSubmitted(false);
      } else {
        console.error("Failed to save changes:", error);
        message.error("Failed to save changes. Please try again.");
        setIsSubmitted(false);
      }

      setIsFetchingDischargeData(false);
    }
  };

  useEffect(() => {
    if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
      dispatch(
        fetchSchemeById(
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
        )
      );
    }
  }, [patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId]);

  const handleIntimateSubmit = async () => {
    let dataToSave: any = {};
    if (dischargeData?.ihxDischargeResponses) {
      dataToSave = {
        dateOfAdmission: dischargeData?.ihxDischargeResponses?.[0]?.[
          "Basic Details"
        ]?.find((field: DischargeField) => field.id === "dateOfAdmission")
          ?.data,
      };

      Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
        Object.entries(fields)?.forEach(([fieldId, value]) => {
          if (fieldId === "dateOfDischarge" || fieldId === "dateOfAdmission") {
            const regex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
            if (
              regex.test(value) &&
              dayjs(value, "DD-MM-YYYY HH:mm:ss", true).isValid()
            ) {
              if (fieldId === "dateOfDischarge")
                dataToSave.dateOfDischarge = value;
              else if (fieldId === "dateOfAdmission")
                dataToSave.dateOfAdmission = value;
            } else {
              const parsedDate = dayjs(value);
              if (fieldId === "dateOfDischarge") {
                dataToSave.dateOfDischarge = parsedDate.isValid()
                  ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                  : null;
              } else if (fieldId === "dateOfAdmission") {
                dataToSave.dateOfAdmission = parsedDate.isValid()
                  ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                  : null;
              }
            }
          } else if (fieldId === "radioButtonForDischargeAndDeath") {
            if (value === "true") {
              delete dataToSave[fieldId];
              dataToSave["death"] = true;
              dataToSave["discharge"] = false;
            } else if (value === "false") {
              delete dataToSave[fieldId];
              dataToSave["discharge"] = true;
              dataToSave["death"] = false;
            }
          } else {
            dataToSave[fieldId] =
              value === "true" ? true : value === "false" ? false : value;
          }
        });
      });

      if (uploadedDocumentUrl) {
        dataToSave.documentUrls = uploadedDocumentUrl;
      }
    } else if (dischargeData?.cghsDischargeResponse) {
      Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
        Object.entries(fields)?.forEach(([fieldId, value]) => {
          if (value === "true") {
            dataToSave[fieldId] = true;
          } else if (value === "false") {
            dataToSave[fieldId] = false;
          } else if (fieldId?.toLowerCase()?.includes("date")) {
            dataToSave[fieldId] =
              value === "" || value === null
                ? null
                : dayjs(value).format("DD-MM-YYYY HH:mm:ss");
          }
          if (fieldId === "radioButtonForDischargeAndDeath") {
            if (value === "death") {
              delete dataToSave[fieldId];
              dataToSave["death"] = true;
              dataToSave["discharge"] = false;
            } else if (value === "discharge") {
              delete dataToSave[fieldId];
              dataToSave["discharge"] = true;
              dataToSave["death"] = false;
            }
          } else {
            dataToSave[fieldId] = value === "" || value === null ? null : value;
          }

          if (fieldId === "surgeryDate" || fieldId === "dateOfDischarge") {
            dataToSave[fieldId] =
              value === "" || value === null
                ? null
                : dayjs(value, "DD-MM-YYYY HH:mm:ss").format(
                    "DD-MM-YYYY HH:mm:ss"
                  );
          }
          if (fieldId?.toLowerCase()?.includes("date")) {
            dataToSave[fieldId] =
              value === "" || value === null
                ? null
                : dayjs(value, "DD-MM-YYYY HH:mm:ss").format(
                    "DD-MM-YYYY HH:mm:ss"
                  );
          }
        });
      });

      dataToSave["dateOfAdmission"] = null;
      dataToSave["DSPath"] = DSPath;

      if (uploadedDocumentUrl) {
        dataToSave.documentUrls = uploadedDocumentUrl;
      }
    } else if (dischargeData?.starHealthDischargeResponse) {
      dataToSave = {
        dateOfAdmission: dischargeData?.starHealthDischargeResponse?.[0]?.[
          "Basic Details"
        ]?.find((field: DischargeField) => field.id === "dateOfAdmission")
          ?.data,
      };

      Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
        Object.entries(fields)?.forEach(([fieldId, value]) => {
          if (
            fieldId === "dateOfDischarge" ||
            fieldId === "dateOfAdmission" ||
            fieldId?.toLowerCase()?.includes("date")
          ) {
            const regex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
            if (
              regex.test(value) &&
              dayjs(value, "DD-MM-YYYY HH:mm:ss", true).isValid()
            ) {
              dataToSave[fieldId] = value;
            } else {
              const parsedDate = dayjs(value);
              dataToSave[fieldId] = parsedDate.isValid()
                ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                : null;
            }
          } else if (fieldId === "roomType") {
            const id = value?.includes("~")
              ? value?.split("~")[0]
              : value?.split(":")[0];
            const roomType = value?.includes("~")
              ? value?.split("~")[1]
              : value?.split(":")[1];
            dataToSave[fieldId] = { id, name: roomType };
          } else {
            dataToSave[fieldId] =
              value === "true" ? true : value === "false" ? false : value;
          }
        });
      });

      if (uploadedDocumentUrl) {
        dataToSave.documentUrls = uploadedDocumentUrl;
      }
    } else if (dischargeData?.echsDischargeResponse) {
      dataToSave = {
        dateOfAdmission: dischargeData?.echsDischargeResponse?.[0]?.[
          "Basic Details"
        ]?.find((field: DischargeField) => field.id === "dateOfAdmission")
          ?.data,
      };

      Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
        Object.entries(fields)?.forEach(([fieldId, value]) => {
          if (
            fieldId === "dateOfDischarge" ||
            fieldId === "dateOfAdmission" ||
            fieldId?.toLowerCase()?.includes("date")
          ) {
            const regex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
            if (
              regex.test(value) &&
              dayjs(value, "DD-MM-YYYY HH:mm:ss", true).isValid()
            ) {
              dataToSave[fieldId] = value;
            } else {
              const parsedDate = dayjs(value);
              dataToSave[fieldId] = parsedDate.isValid()
                ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                : null;
            }
          } else if (fieldId === "roomType") {
            dataToSave[fieldId] = { id: null, name: value };
          } else {
            dataToSave[fieldId] =
              value === "true" ? true : value === "false" ? false : value;
          }
        });
      });

      if (uploadedDocumentUrl) {
        dataToSave.documentUrls = uploadedDocumentUrl;
      }

      dataToSave["DSPath"] = DSPath;
    }

    const resp = await dispatch(
      intimateSubmitDischarge({
        caseId: getIds?.fetchBasicDetails?.casesResponse?.id,
        visitId: getIds?.fetchBasicDetails?.visitInfoResponse?.id,
        portalMetaDataId: discharge?.selectedScheme?.portalMetaDataIdsList[0],
        intimationData: dataToSave,
      })
    );

    if (intimateSubmitDischarge.fulfilled.match(resp)) {
      if (resp.payload?.status == 200) {
        setIsFetchingDischargeData(true);
        const newData = await dischargeService.getDischargeData(
          getIds?.fetchBasicDetails?.casesResponse?.id,
          getIds?.fetchBasicDetails?.visitInfoResponse?.id,
          discharge?.selectedScheme?.portalMetaDataIdsList[0]
        );
        setIsFetchingDischargeData(false);
        getAttachmentsWithValues(newData);
        dispatch(setDischargeDataSuccess(newData));
        if (newData?.ihxDischargeResponses) {
          // Update Discharge Id with the new value
          const newCaseDischargeId =
            newData?.ihxDischargeResponses?.[0]?.["Basic Details"]?.[0]
              ?.caseDischargeId;
          if (newCaseDischargeId) {
            setCaseDischargeId(newCaseDischargeId);
          }
          const portalSubmitCheck =
            newData?.ihxDischargeResponses?.[0]?.["Basic Details"]?.[0]?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
        } else if (newData?.cghsDischargeResponse) {
          // Update Discharge Id with the new value
          const newCaseDischargeId =
            newData?.cghsDischargeResponse?.[0]?.["Discharge"]?.[0]
              ?.caseDischargeId;
          if (newCaseDischargeId) {
            setCaseDischargeId(newCaseDischargeId);
          }
          const portalSubmitCheck =
            newData?.cghsDischargeResponse?.[0]?.["Discharge"]?.[0]?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
        } else if (newData?.starHealthDischargeResponse) {
          // Update Discharge Id with the new value
          const newCaseDischargeId =
            newData?.starHealthDischargeResponse?.[0]?.["Basic Details"]?.[0]
              ?.caseDischargeId;
          if (newCaseDischargeId) {
            setCaseDischargeId(newCaseDischargeId);
          }

          const portalSubmitCheck =
            newData?.starHealthDischargeResponse?.[0]?.["Basic Details"]?.[0]
              ?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
        } else if (newData?.echsDischargeResponse) {
          // Update Discharge Id with the new value
          const newCaseDischargeId =
            newData?.echsDischargeResponse?.[0]?.["Basic Details"]?.[0]
              ?.caseDischargeId;
          if (newCaseDischargeId) {
            setCaseDischargeId(newCaseDischargeId);
          }

          const portalSubmitCheck =
            newData?.echsDischargeResponse?.[0]?.["Basic Details"]?.[0]?.status;
          if (portalSubmitCheck) {
            setPortalSubmission(portalSubmitCheck);
          }
        }
        dispatch(setToggleEditMode(false));

        successMessage("DISCHARGE INTIMATED SUCCESSFULLY");
        onfetchStepper();
      }

      // successMessage()
    } else if (intimateSubmitDischarge.rejected.match(resp)) {
      successMessage("FAILED TO INTIMATE!");
      setIsFetchingDischargeData(false);
    }
  };

  const [isApproved, setIsApproved] = useState<any>(false);
  const [isApprovedInitiated, setIsApprovedInitiated] =
    useState<boolean>(false);

  useEffect(() => {
    if (discharge?.dischargeData?.cghsDischargeResponse) {
      setIsApproved(
        discharge?.dischargeData?.cghsDischargeResponse[0]?.["approved"]
      );
    } else if (discharge?.dischargeData?.ihxDischargeResponses) {
      setIsApproved(
        discharge?.dischargeData?.ihxDischargeResponses[0]?.["approved"]
      );
    } else if (discharge?.dischargeData?.echsDischargeResponse) {
      setIsApproved(
        discharge?.dischargeData?.echsDischargeResponse[0]?.["approved"]
      );
    } else if (discharge?.dischargeData?.starHealthDischargeResponse) {
      setIsApproved(
        discharge?.dischargeData?.starHealthDischargeResponse[0]?.["approved"]
      );
    }
  }, [discharge?.dischargeData]);

  const handleApprove = async () => {
    try {
      setIsApprovedInitiated(true);
      const formData = {
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        stage: "Discharge",
        approved: true,
      };
      const res = await submitApproval(formData);
      setIsApproved(true);
      setIsApprovedInitiated(false);
    } catch (err) {
      errorMessage("Please, Try again later");
      setIsApprovedInitiated(false);
      setIsApproved(false);
    }
  };

  return (
    <div>
      {isFetchingDischargeData ? (
        <Loader />
      ) : (
        <Discharge
          activeStep={activeStep}
          allWizardSteps={allWizardSteps}
          onNext={handleNext}
          onPrevious={handlePrevious}
          onComplete={handleComplete}
          handleFileChange={handleFileChange}
          dischargeData={dischargeData}
          isLoading={isLoading}
          error={error}
          editMode={editMode}
          onToggleEditMode={handleToggleEditMode}
          onFieldChange={handleFieldChange}
          onSaveChanges={handleSaveChanges}
          onSaveChangesInEdgePro={handleSaveChangesInEdgePro}
          editedFields={editedFields}
          caseDischargeId={caseDischargeId}
          handleTabsChange={handleTabsChange}
          portalSubmission={portalSubmission}
          uploadedDocumentUrl={uploadedDocumentUrl}
          viewFile={viewFile}
          handleDeleteList={handleDeleteList}
          handleSetDocumentUrl={handleSetDocumentUrl}
          handleOpen={handleOpen}
          treatingDoctorTypeOptions={treatingDoctorTypeOptions}
          doctorTypeNameList={discharge?.doctorTypeList}
          onKeyDown={onKeyDown}
          handleDownloadDocument={handleDownloadDocument}
          isDownloadingDocument={isDownloadingDocument}
          downloadingDocumentUrl={downloadingDocumentUrl}
          isSubmitting={isSubmitting}
          isSubmitted={isSubmitted}
          handleDeficiencyModal={handleDeficiencyModalOpen}
          closeDeficiencyModal={closeDeficiencyModal}
          deficiencyModal={deficiencyModal}
          deficiencyQuestions={patients?.deficiencyCheckQuestions}
          previewDocumentUrl={previewDocumentUrl}
          setDocumentName={setDocumentName}
          handleDeficiencyModalAfterSave={handleDeficiencyModalAfterSave}
          starHealthRoomTypeOptions={discharge?.starHealthRoomTypeList}
          handleIntimateSubmit={handleIntimateSubmit}
          auth={auth}
          nextStage={nextStage}
          setMoveToNext={setMoveToNext}
          preAuth={preAuth}
          handleApprove={handleApprove}
          isApproved={isApproved}
          isApprovedInitiated={isApprovedInitiated}
        />
      )}

      <FilePreviewModal
        isVisible={previewModalVisible}
        onClose={() => setPreviewModalVisible(false)}
        fileUrl={previewFile.url}
        fileName={previewFile.name}
        documentType={previewFile.documentType}
        handleUpload={handleUpload}
        showUploadButton={previewFile.showUpload}
        key={selectedFile?.file?.lastModified || "no-file"}
        isLoading={discharge?.isLoading}
      />
      <RightSidePreviewModal
        key={documentUrl}
        documentUrl={documentUrl}
        handleCancel={handleCancelPreview}
        open={previewDocument}
      />
      <DocumentDeficiencyModal
        key={previewDocumentUrl}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        documentUrl={previewDocumentUrl}
        documentName={documentName}
        handleDownloadDocument={handleDownloadDocument}
        isDownloadingDocument={isDownloadingDocument}
        downloadingDocumentUrl={downloadingDocumentUrl}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setUploadedDocumentUrl}
      />
    </div>
  );
};

export default DischargeContainer;
